import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  margin: 0.5rem 0;
`;

export const StateZeroContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 0.5rem;
  height: 10rem;

  & > span {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark4};
    margin-top: 2.5rem;
  }
`;
